export default from './MobileMessages';



// WEBPACK FOOTER //
// ./src/components/LoanOfficerMessages/components/MobileMessages/index.js